var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBrakesSusIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "SE 40mm@2x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SE-40mm",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Brakes-&-Supensions",
    transform: "translate(1, 1)",
    fill: "#00095B"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Brakes-&-Supensions-2",
    transform: "translate(0, 1.8333)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.18675,3.33411 L15.87485,5.6729 C16.0645,5.93625 16.1075,6.181 15.9208,6.3956 C15.86555,6.4591 15.771,6.4623 15.7082,6.47855 L14.4766,6.50455 L13.7545,6.55905 L12.6024,5.5567 L14.04665,5.44775 L12.51055,4.11129 C12.21335,3.800835 12.46465,3.38859 12.46465,3.38859 C12.46465,3.38859 12.8585,3.088125 13.18675,3.33411 Z",
    id: "Path",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.69915,5.0439 L14.3873,7.3827 C14.5769,7.64605 14.61995,7.89075 14.4332,8.1054 C14.37795,8.1689 14.2834,8.17205 14.2206,8.1883 L12.989,8.21435 L12.2669,8.2688 L11.11485,7.2665 L12.55905,7.15755 L11.023,5.8211 C10.72575,5.51065 10.97705,5.0984 10.97705,5.0984 C10.97705,5.0984 11.37095,4.797915 11.69915,5.0439 Z",
    id: "Path",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.21155,6.7537 L12.8997,9.0925 C13.0893,9.35585 13.13235,9.60055 12.9456,9.8152 C12.89035,9.8787 12.79585,9.88185 12.733,9.8981 L11.5014,9.92415 L10.7793,9.9786 L9.62725,8.9763 L11.07145,8.8673 L9.5354,7.5309 C9.23815,7.2204 9.48945,6.8082 9.48945,6.8082 C9.48945,6.8082 9.88335,6.5077 10.21155,6.7537 Z",
    id: "Path",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.72395,8.4635 L11.4121,10.80225 C11.6017,11.0656 11.64475,11.31035 11.458,11.52495 C11.4028,11.58845 11.30825,11.59165 11.24545,11.6079 L10.0138,11.63395 L9.2917,11.6884 L8.13965,10.68605 L9.58385,10.5771 L8.0478,9.24065 C7.75055,8.9302 8.00185,8.51795 8.00185,8.51795 C8.00185,8.51795 8.39575,8.2175 8.72395,8.4635 Z",
    id: "Path",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.2364,10.1733 L9.9245,12.51205 C10.1141,12.7754 10.15715,13.02015 9.97045,13.23475 C9.9152,13.29825 9.82065,13.30145 9.75785,13.3177 L8.5262,13.3437 L7.8041,13.3982 L6.65205,12.39585 L8.09625,12.2869 L6.5602,10.95045 C6.263,10.64 6.51425,10.22775 6.51425,10.22775 C6.51425,10.22775 6.90815,9.9273 7.2364,10.1733 Z",
    id: "Path",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.9998,0 C15.8594,0 19.7999,3.91694 19.7999,8.75 C19.7999,13.58195 15.8594,17.5 10.9998,17.5 C6.14015,17.5 2.199645,13.58195 2.199645,8.75 C2.199645,3.91694 6.14015,0 10.9998,0 Z M3.793025,0.490251 L4.575805,1.26857 C2.45144,3.075455 1.09988,5.75765 1.09988,8.74965 C1.09988,11.74165 2.45144,14.4239 4.575805,16.23075 L3.793025,17.0091 C1.4702,15.00375 0,12.04815 0,8.74965 C0,5.4512 1.4702,2.495575 3.793025,0.490251 Z M18.20695,0.490582 C20.5298,2.495905 22,5.4515 22,8.75 C22,12.04845 20.5298,15.0041 18.20695,17.0094 L17.4242,16.2311 C19.54855,14.4242 20.9001,11.742 20.9001,8.75 C20.9001,5.758 19.54855,3.075785 17.4242,1.2689 L18.20695,0.490582 Z M10.9998,1.09361 C6.7544,1.09361 3.299525,4.527685 3.299525,8.75 C3.299525,12.9723 6.7544,16.4064 10.9998,16.4064 C15.2463,16.4064 18.70005,12.9723 18.70005,8.75 C18.70005,4.527685 15.2463,1.09361 10.9998,1.09361 Z",
    id: "Shape",
    stroke: "#00095B",
    strokeWidth: 0.4
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrakesSusIcon);
export default __webpack_public_path__ + "static/media/brakes-sus-icon.c0648b2ce1ff666049284f1fd9936056.svg";
export { ForwardRef as ReactComponent };